// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.practicepreferences.CreateWebServiceUserRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateWebServiceUserRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Partner Key cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	partnerKey!: string | null;

	@GandalfConstantDecorator(constants.WebServiceUserServiceType)
	@GandalfValidator({ notNull: { message: 'Service Type is required' } })
	@GandalfProperty({ designType: constants.WebServiceUserServiceType, isRequired: true })
	serviceType!: constants.WebServiceUserServiceType;

}
